import {
    MarketDataApi,
    WalletManagementApi,
    UserDataApi,
    BuyCryptoApi,
    CmsApi,
    AuthApi,
    RegApi,
    FeaturesApi,
    HostApi,
    EnsApi,
    VcardsApi,
    FiatWithdrawalApi,
    CardsApi,
    SpotTradingApi,
} from '@web/walter-lib/api'

const publicURL = import.meta.env.VITE_PUBLIC_API_URL || ''
const cmsURL = import.meta.env.VITE_CMS_API_URL || ''
const authURL = import.meta.env.VITE_AUTH_API_URL || ''
const regURL = import.meta.env.VITE_REG_API_URL || ''

export const marketApi = new MarketDataApi({
    baseURL: publicURL,
    shouldValidateResponse: false,
})

export const walletApi = new WalletManagementApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const userApi = new UserDataApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const buyCryptoApi = new BuyCryptoApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const featuresApi = new FeaturesApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const hostApi = new HostApi({
    baseURL: authURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const cmsApi = new CmsApi({
    baseURL: cmsURL,
    shouldValidateResponse: false,
})

export const authApi = new AuthApi({
    baseURL: authURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const regApi = new RegApi({
    baseURL: regURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const ensApi = new EnsApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const vcardsApi = new VcardsApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const fiatWithdrawalApi = new FiatWithdrawalApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const cardsApi = new CardsApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})

export const spotApi = new SpotTradingApi({
    baseURL: publicURL,
    config: {
        withCredentials: true,
    },
    shouldValidateResponse: false,
})
